/**
 * 定制化加载
 * 根据配置数据确定是否加载定制化的js包
 */
(function (win) {
    let exportData;
    let loadingEl;
    const loadTemplate = '<div style="font-size:0.56rem;color:#ffffff">定制化加载....</div>';

    const wrapFun = (path) => {
        try {
            exportData = window.require(path);
        } catch (e) {
            exportData = require(path); // eslint-disable-line
        }
        return exportData;
    };
    const createLoadingBox = () => {
        if (!loadingEl) {
            loadingEl = document.createElement('div');
            loadingEl.innerHTML = loadTemplate;
            loadingEl.style.position = 'fixed';
            loadingEl.style.zIndex = 1001;
            loadingEl.style.top = 0;
            loadingEl.style.left = 0;
            loadingEl.style.right = 0;
            loadingEl.style.bottom = 0;
            loadingEl.style.display = 'flex';
            loadingEl.style['align-items'] = 'center';
            loadingEl.style['justify-content'] = 'center';
            loadingEl.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        }
        document.body.appendChild(loadingEl);
    };
    const removeLoadingBox = () => {
        if (loadingEl.parentNode) document.body.removeChild(loadingEl);
    };

    const poll = (node, callback) => {
        let isLoaded = false;
        if (callback.isCalled) {
            return;
        }
        if (/webkit/i.test(navigator.userAgent)) { // webkit
            if (node.sheet) {
                isLoaded = true;
            }
        } else if (node.sheet) { // for Firefox
            try {
                if (node.sheet.cssRules) {
                    isLoaded = true;
                }
            } catch (ex) {
                // NS_ERROR_DOM_SECURITY_ERR
                if (ex.code === 1000) {
                    isLoaded = true;
                }
            }
        }
        if (isLoaded) {
            // give time to render.
            setTimeout(() => {
                callback();
            }, 1);
        } else {
            setTimeout(() => {
                poll(node, callback);
            }, 1);
        }
    };
    const checkStyleOnload = (node, callback) => {
        // for IE6-9 and Opera
        if (node.attachEvent) {
            node.attachEvent('onload', callback);
        } else { // polling for Firefox, Chrome, Safari
            setTimeout(() => {
                poll(node, callback);
            }, 0); // for cache
        }
    };
    // 检测是否需要加载定制化模块
    const needLoadCustomModule = (global, m) => {
        const customModules = global.zxyCustomModules;
        let res = false;
        if (customModules && customModules.modules) {
            res = customModules.modules.find((n) => {
                return m === n.moduleName;
            });
            if (res && !res.isLoad) {
                res.styleLoadPath = customModules.styleLoadPath;
                if (process.env.NODE_ENV !== 'development') {
                    res.styleLoadPath = `vue/css/${customModules.styleLoadPath}`;
                    res.moduleLoadPath = `vue/js/${customModules.moduleLoadPath}`;
                }
            }
        }
        return res;
    };

    // 加载定制化样式
    const customStyleLoad = (path, callback) => {
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = path;
        document.head.appendChild(link);
        checkStyleOnload(link, callback);
    };

    // 加载定制化模块包
    const customModuleLoad = (obj, global, resolve, reject) => {
        let dom;
        const ins = global;
        if (obj.styleLoadPath && !ins.customVueCssLoad) {
            customStyleLoad(obj.domain + obj.styleLoadPath, () => {
                dom = document.createElement('script');
                dom.src = obj.domain + obj.moduleLoadPath;
                dom.onload = () => {
                    obj.isLoad = true;
                    removeLoadingBox();
                    resolve();
                };
                dom.onerror = reject;
                document.head.appendChild(dom);
                ins.customVueCssLoad = true;
            });
        } else {
            dom = document.createElement('script');
            dom.src = obj.domain + obj.moduleLoadPath;
            dom.onload = () => {
                obj.isLoad = true;
                removeLoadingBox();
                resolve();
            };
            dom.onerror = reject;
            document.head.appendChild(dom);
        }
    };

    // 检测模块是否定制化, 加载对应的定制化包
    const doCustomLoad = (chunkName) => {
        const p = new Promise((resolve, reject) => {
            const cm = needLoadCustomModule(win, chunkName);
            if (cm && !cm.isLoad && cm.from === 'vue') {
                createLoadingBox();
                customModuleLoad(cm, win, resolve, reject);
            } else {
                resolve();
            }
        });
        return p;
    };
    win.wrapRequire = wrapFun;
    win.customRequire = doCustomLoad;
}(window));
